import { Injectable } from "@angular/core";
import { GenericService } from "../../../core/commons/generic.service";
import { Message } from "../../domain/message";
import { AuthService } from "../../../core/security/auth.service";
import { QueryOptions } from "../../../core/commons/query.options";
import { Conversation } from "../../domain/conversation";
import { BaseRequestOptions, RequestMethod } from "@angular/http";

@Injectable()
export class MessageService extends GenericService<Message> {
  constructor(authService: AuthService) {
    super(authService);
  }

  protected valueToEntity(value: Object): Message {
    return new Message(value);
  }

  protected getResourcePath(): string {
    return "/chat/message";
  }

  public getDefaultQueryOptions(): QueryOptions {
    return new QueryOptions();
  }

  public getMessagesByConversation(
    c: Conversation,
    pageSize: number,
    page: number
  ) {
    let reqOptions = new BaseRequestOptions();
    reqOptions.method = RequestMethod.Get;
    return this.authService
      .authRequest(
        this.baseUrl +
          this.getResourcePath() +
          "/" +
          c.id +
          "/" +
          pageSize +
          "/" +
          page,
        reqOptions
      )
      .map(res => res.json().content.map(t => this.valueToEntity(t)));
  }

  public changeMessageState(msgId: number, state: boolean): void {
    let req = this.buildRequest(
      RequestMethod.Post,
      JSON.stringify({ messageId: msgId, state: state })
    );
    this.authService
      .authRequest(this.baseUrl + this.getResourcePath() + "/update", req)
      .subscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/fiscalia/service/chat/message.service.ts